<template>
  <div v-if="false">
    <!-- IS NAKED -->
    <div
      v-if="!isButton"
      itemprop="offers"
      itemscope
      itemtype="http://schema.org/Offer"
      class="card-row has-text-weight-normal has-text-black-ter"
      :class="[isMedium]"
    >
      <!-- <meta
        itemprop="validFrom"
        :content="$options.filters.toHTMLDateTime(new Date(eventShowtimes[0].startTime))"
      /> -->
      <link itemprop="availability" href="http://schema.org/InStock" />
      <meta v-if="!eventTicketInfo.isFree" itemprop="priceCurrency" content="TRY" />
      <meta v-if="eventTicketInfo.isFree" itemprop="isAccessibleForFree" content="true" />
      <meta v-if="eventTicketInfo.isFree" itemprop="publicAccess" content="true" />
      <!-- TODO starts from for ensligh -->
      <span
        v-if="!eventTicketInfo.isFree"
        :to="{name: 'event-view', params: {eventID: eventId}}"
        itemprop="price"
        :content="calcMainTicketPrice(eventTicketInfo)"
      >{{ calcMainTicketPrice(eventTicketInfo) }}&nbsp;₺</span>
      <span v-if="eventTicketInfo.isFree">{{ calcMainTicketPrice(eventTicketInfo) }}</span>

      <link itemprop="url" :href="`https://hafta8.com/event/${eventId}`" />
    </div>

    <!-- IS BUTTON -->
    <button
      class="button is-small is-rounded is-danger is-outlined"
      v-else
      itemprop="offers"
      itemscope
      itemtype="http://schema.org/Offer"
    >
      <!-- <button class="button  is-danger is-small is-rounded">{{ $t('ui.buyTicket') }}</button> -->

      <!-- <meta
        itemprop="validFrom"
        :content="$options.filters.toHTMLDateTime(new Date(eventShowtimes[0].startTime))"
      /> -->
      <link itemprop="availability" href="http://schema.org/InStock" />
      <meta v-if="!eventTicketInfo.isFree" itemprop="priceCurrency" content="TRY" />
      <meta v-if="eventTicketInfo.isFree" itemprop="isAccessibleForFree" content="true" />
      <meta v-if="eventTicketInfo.isFree" itemprop="publicAccess" content="true" />
      <span
        v-if="!eventTicketInfo.isFree"
        :to="{name: 'event-view', params: {eventID: eventId}}"
        itemprop="price"
        :content="calcMainTicketPrice(eventTicketInfo)"
      >{{ calcMainTicketPrice(eventTicketInfo) }}&nbsp;₺</span>
      <span v-if="eventTicketInfo.isFree">{{ calcMainTicketPrice(eventTicketInfo) }}</span>

      <link itemprop="url" :href="`https://hafta8.com/event/${eventId}`" />
    </button>
  
  </div>
</template>

<script>
import { ticketPriceMixin } from "@/mixins/ticket";
export default {
  name: "card-price",
  mixins: [ticketPriceMixin],
  props: {
    eventTicketInfo: {
      type: Object,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    isButton: {
      type: Boolean,
      default: false
    },
    isMedium: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textSize() {
      return isMedium ? 'is-size-6' : 'is-size-13px'
    }
  }
};
</script>